import { AggregatedActivityCard } from "@adsk/alloy-react-activity-log";
import React from "react";
import styled from "styled-components";
import { ActivityLogCardCommonProps } from "../activityLogTypes";

interface AggregatedActivityCardItem {
  label: React.ReactNode;
  value: React.ReactNode;
}

const CustomActivityListRow = styled(AggregatedActivityCard.ListRow)`
  .IssuesActivityLog__aggregated-card-list-row {
    align-items: baseline;
    display: flex;
    margin-bottom: 8px;
  }

  /* Fixing the font for the activity values */
  .activity-value {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    word-break: break-word;
  }

  /* This styling affects the row's label, fixing a line-break issue for long activities */
  .activity-label {
    min-width: 116px;
    word-break: break-word;
  }
`;

const aggregatedCardRenderRow = (props: any) => {
  return (
    <CustomActivityListRow {...props}>
      {(listRowProps: AggregatedActivityCardItem) => (
        <div className="IssuesActivityLog__aggregated-card-list-row">
          <div className="activity-label">{listRowProps.label}</div>
          <div className="activity-value">{listRowProps.value}</div>
        </div>
      )}
    </CustomActivityListRow>
  );
};

export const AggregatedChangesActivityCard = ({
  activityItems,
  ...props
}: ActivityLogCardCommonProps & {
  activityItems: AggregatedActivityCardItem[];
}) => (
  <AggregatedActivityCard
    items={activityItems}
    {...props}
    renderRow={aggregatedCardRenderRow}
    className="IssuesActivityLog__activity-card IssuesActivityLog__activity-card--aggregated"
    data-testid="aggregated-changes-activity-card"
  />
);
